// features/auth/authSlice.js

import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import apiAxios from "../../services/apiAxios";
import { getStoreDetails } from "../Thunk/Store/StoreThunks";
import { getAdminDetails } from "../Thunk/AdminAccount.js/AccountThunk";
import { setLoading } from "./Doctor/DoctorSlice";
import toast from "react-hot-toast";

// Async thunks for different logins
export const doctorLogin = createAsyncThunk(
  "auth/doctorLogin",
  async ({ contactNumber, pin, fcmToken }, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post("api/auth/doctor/login", {
        contactNumber,
        pin,
        fcmToken,
      });
      localStorage.setItem("token", response?.data?.token);
      localStorage.setItem("refreshToken", response?.data?.refreshToken);
      if (response?.data?.doctor?.DID) {
        localStorage.setItem("DID", response?.data?.doctor?.DID);
      }
      if (response?.data?.token) {
        // dispatch(getDoctorDetails(response?.data?.token));
        dispatch(setLoading(false));
      }
      return { role: "doctor", user: response.data };
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      else toast.error(error?.message);
      dispatch(setLoading(false));
      return rejectWithValue(
        error.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const storeLogin = createAsyncThunk(
  "auth/storeLogin",
  async ({ username, pin, fcmToken }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAxios.post("api/auth/store/login", {
        username,
        pin,
        fcmToken,
      });
      localStorage.setItem("token", response?.data?.token);
      localStorage.setItem("refreshToken", response?.data?.refreshToken);
      if (response?.data?.token) {
        dispatch(getStoreDetails(response?.data?.token));
      }
      return { role: "store", user: response.data };
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      else toast.error(error?.message);
      return rejectWithValue(
        error.response?.data?.message || "An error occurred"
      );
    }
  }
);

export const adminLogin = createAsyncThunk(
  "auth/adminLogin",
  async ({ username, pin }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAxios.post("api/auth/admin/login", {
        username,
        pin,
      });
      dispatch(getAdminDetails(response?.data?.token));
      localStorage.setItem("token", response?.data?.token);
      localStorage.setItem("refreshToken", response?.data?.refreshToken);
      return { role: "admin", user: response.data };
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      else toast.error(error?.message);
      return rejectWithValue(
        error.response?.data?.message || "An error occurred"
      );
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    role: null, // Could be 'doctor', 'store', or 'admin'
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.role = null;
      state.user = null;
      localStorage.removeItem("token");
      localStorage.clear();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doctorLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doctorLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.role = action.payload.role;
        state.user = action.payload.user;
      })
      .addCase(doctorLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(storeLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(storeLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.role = action.payload.role;
        state.user = action.payload.user;
      })
      .addCase(storeLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(adminLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.role = action.payload.role;
        state.user = action.payload.user;
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const resetAllState = createAction("RESET_ALL_STATE");
export const { logout } = authSlice.actions;
export default authSlice.reducer;
